import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';


const CardTypePreview = ({value, options, translate}) => {
  const {t} = useTranslation(translate || 'common');
  
  const data = value ? (Array.isArray(value) ? value : null) : null;
  if (!data || !data.length) return t('all');
  
  return <div>{
    options
      ?.filter(option => data.includes(option.value))
      ?.map(option => t(option.label))
      ?.map(option => <div key={option}>{option}</div>)
  }</div>;
};

CardTypePreview.propTypes = {
  translate: PropTypes.string,
  value: PropTypes.array,
  options: PropTypes.array,
};

export default memo(CardTypePreview);
